import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import HubspotMeetings from '@/components/landing/HubspotMeetings';
import { CONTACT_EMAIL } from '@/config/marketing';

export default function ContactSection() {
    const { t } = useTranslation(['admin']);
    return (
        <section id="contact" className="relative py-32 bg-[#0a0a0a]">
            {/* Gradient line */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

            {/* Background glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-purple-600/10 rounded-full blur-[150px]" />

            <div className="relative max-w-4xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-12"
                >
                    <span className="text-xs uppercase tracking-[0.2em] text-purple-400 mb-4 block">
                        {t('admin:landing.contact.label')}
                    </span>
                    <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4">
                        {t('admin:landing.contact.heading')}
                    </h2>
                    <p className="text-white/40 text-lg max-w-md mx-auto">
                        {t('admin:landing.contact.subheading')}
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.1 }}
                    className="relative"
                >
                    <div className="rounded-3xl bg-white/[0.02] border border-white/[0.05] p-6 sm:p-8 md:p-12">
                        <HubspotMeetings className="rounded-xl overflow-hidden" />
                    </div>

                    {/* Alternative contact */}
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-10 text-sm">
                        <a href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-2 text-white/40 hover:text-white/60 transition-colors">
                            <Mail className="w-4 h-4" />
                            {CONTACT_EMAIL}
                        </a>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}